import script from "./ActivityCoupon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityCoupon.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityCoupon.vue?vue&type=style&index=0&id=4e55343e&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e55343e"]])

export default __exports__